<template>
    <b-modal
        v-model="modal"
        :id="'rubric-column-cell-content-edit'"
        :title="$t('rubrics.edit_description')"
        @ok="onOk"
        :ok-disabled="value === ''"
        :ok-title="$t('common.save')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        modal-class="apprentice-default-modal rubric-column-cell-content">
        <div class="rubric-skill-description">
            <b-form-group>
                <b-form-textarea
                    class="apprentice-textarea"
                    id="rubric-skill-description-textarea"
                    v-model="value"
                    :placeholder="$t('common.description')"
                    rows="5">
                </b-form-textarea>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-rubric-form-column-cell-content-edit-modal-component',
    props: {
        columnIn: Object,
        rowId: Number,
    },
    data() {
        return {
            cell: this.columnIn.getCellForRow(this.rowId),
            value: this.cell ? this.cell.value : '',
            modal: false,
        };
    },
    methods: {
        show() {
            this.cell = this.columnIn.getCellForRow(this.rowId);
            this.value = this.cell ? this.cell.value : '';
            this.modal = true;
        },

        onOk() {
            if (this.cell) {
                this.updateCellContent();
            } else {
                this.storeCellContent();
            }
        },

        storeCellContent() {
            const data = {
                column_id: this.columnIn.id,
                row_id: this.rowId,
                value: this.value,
            };

            this.axios.post(this.routes.addRubricCell(), data).then(
                (response) => {
                    this.columnIn.addRelation('rubric_cells', response.data);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        updateCellContent() {
            const data = {
                value: this.value,
            };

            this.axios.post(this.routes.updateRubricCell(this.cell.id), data).then(
                (response) => {
                    this.cell.update(response.data);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped></style>
